import get from 'lodash/get'

import {
  positiveNumber,
  isInteger,
  isChecked,
  required,
  moreThanOrEqualToField,
} from '../../utils/validations'
import messages from '../../i18n'

const validate = (values: any) => ({
  net3MonthIncome:
    required(get(values, 'net3MonthIncome')) ||
    isInteger(get(values, 'net3MonthIncome')) ||
    positiveNumber(get(values, 'net3MonthIncome')),
  net3MonthHouseholdIncome:
    required(get(values, 'net3MonthHouseholdIncome')) ||
    isInteger(get(values, 'net3MonthHouseholdIncome')) ||
    positiveNumber(get(values, 'net3MonthHouseholdIncome')) ||
    moreThanOrEqualToField(
      parseFloat(get(values, 'net3MonthHouseholdIncome')),
      parseFloat(get(values, 'net3MonthIncome')),
      messages.FinanceIncome.netIncomeCompared
    ),
  taxCrOnlyFlag: isChecked(get(values, 'taxCrOnlyFlag'), messages.FinanceIncome.taxCrOnlyFlag),
})

export default validate
